export class Establishment {

  id:number;
  designation:string;
  abbreviation:string;
  logo : string;   //image base 64
  license_expiration_date : Date

}
